import axios from 'axios'
import Utils from '@/utils/index'
import base_url from './baseUrl'

const url = process.env.NODE_ENV == 'development' ? base_url.dev : base_url.prod

const httpClient = axios.create({
  baseURL: base_url.prod,
  timeout: 60000 // 超时时间
})

httpClient.defaults.withCredentials = false
// 添加请求拦截器
httpClient.interceptors.request.use(
  config => {
    if (Utils.getWithExpiry('token')) {
      config.headers.Authorization = 'Bearer ' + Utils.getWithExpiry('token')
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
httpClient.interceptors.response.use(
  // 请求成功
  res => {
    return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
  },
  // 请求失败
  error => {
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      // errorHandle(response.status, response.data.error.message)
      return Promise.reject(response)
    }
  }
)

export default httpClient
